import { useCallback } from "react";
import { IUserSubprofileModel, useInitialHomePage } from "@nf/common";
import { useRouter } from "./useRouter";
import { useRedirectUrlParam } from "./useRedirectUrlParam";

export const useSwitchProfileWithRedirection = () => {
  const router = useRouter();
  const redirectUrl = useRedirectUrlParam();
  const { getInitialHomePage } = useInitialHomePage();

  return useCallback(
    (subProfile?: IUserSubprofileModel) => {
      if (redirectUrl) {
        router.replace(redirectUrl, undefined, { withLoadingSplash: true });
      } else {
        const url = getInitialHomePage(subProfile);

        router.replace(url, undefined, {
          withLoadingSplash: true,
        });
      }
    },
    [redirectUrl]
  );
};
